import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
import User from '../../models/user';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import convertUrlfromS3toCloudFront from '../../utils/convertUrlfromS3toCloudFront';

const Button = styled.div`
  display: flex;
  justify-content: center;
`;
const ProfileAvatar = styled.div`
  position: relative;
  text-align: center;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  font-size: ${Constants.SemiLargeFontSize};
`;

export default class UserAvatar extends LogictryComponent {
  static propTypes = {
    user: PropTypes.object,
    onClick: PropTypes.func,
    buttonRef: PropTypes.func,
    showShadow: PropTypes.bool,
    mini: PropTypes.bool,
    widthAndHeight: PropTypes.number,
    showLive: PropTypes.bool
  }

  render() {
    const { user, buttonRef, onClick, showShadow, mini, widthAndHeight, showLive } = this.props;
    const profileSize = widthAndHeight || mini && 22 || 32;
    const backgroundImage = user && (new User(user)).getImage();
    const boxShadow = showShadow ? 'unset' : 'unset';
    return (
      <Button
        ref={buttonRef}
        onClick={onClick}
        style={{ cursor: onClick ? 'pointer' : null, position: 'relative' }}
      >
        <ProfileAvatar
          style={{
            width: profileSize,
            height: profileSize,
            fontSize: profileSize,
            backgroundImage: `url("${convertUrlfromS3toCloudFront(backgroundImage, 480, 480) || Constants.Avatar}")`,
            boxShadow
          }}
        />
        {showLive && <div style={{ width: 9, height: 9, padding: 1, position: 'absolute', bottom: 1, right: 1, background: 'white', borderRadius: '50%' }}>
          <div style={{ width: 7, height: 7, background: 'lightgreen', borderRadius: '50%' }} />
        </div>}
      </Button>
    );
  }

}
